import { useEffect, useState } from 'react';
import type { DisplayPublic } from '../api';
import { ChannelChrome } from './ChannelChrome';

export function SignageChannel({
  display,
  connected,
  onUnpair,
}: {
  display: DisplayPublic;
  connected: boolean;
  onUnpair: () => void;
}) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30_000);
    return () => clearInterval(id);
  }, []);

  return (
    <ChannelChrome display={display} connected={connected} onUnpair={onUnpair}>
      <div className="flex flex-1 flex-col items-center justify-center px-12 text-center">
        <div className="text-xs uppercase tracking-[0.4em] text-white/40">
          {now.toLocaleDateString(undefined, {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
          })}
        </div>
        <h1 className="mt-6 text-8xl font-extrabold tracking-tight">
          Welcome to
          <br />
          {display.venueName}
        </h1>
        <p className="mt-8 text-2xl text-white/50">
          Powered by {display.orgName}
        </p>
        <div className="mt-16 font-mono text-3xl text-white/30">
          {now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </div>
      </div>
      <div className="border-t border-white/5 px-8 py-4 text-center text-sm text-white/30">
        Signage channel · custom messages land here when admin pushes them
      </div>
    </ChannelChrome>
  );
}
